import React from "react";
import ReactGA from "react-ga4";

const AnalyticsEventTracker = (category="Default category") => {
  const eventTracker = (action = "default action", label = "default label") => {
    ReactGA.event({ category, action, label });
  }
  return eventTracker;
}

export default AnalyticsEventTracker;


// WEBPACK FOOTER //
// ./src/components/Analytics.js